export class ApiEndpoints {
  public static readonly GET_ALL_USERS = './getAllUsers';
  public static readonly GET_NETWORK_SERVER = './getNetworkServer';
  public static readonly GET_NETWORK_SERVER_GROUP = './getNetworkServerGroup';
  public static readonly GET_JOIN_SERVER = './getJoinServer';
  public static readonly GET_ROAMING_COMMUNITY = './getRoamingCommunity';
  public static readonly PLATFORMS = './platforms';
  public static readonly GET_ALL_NETWORK_SERVER_GROUPS = './getAllNetworkServerGroups';
  public static readonly GET_ALL_NETWORK_SERVERS = './getAllNetworkServers';
  public static readonly GET_ALL_JOIN_SERVERS = './getAllJoinServers';
  public static readonly GET_USER = './getUser';
  public static readonly GET_JOIN_SERVER_STATUS = './getJoinServerStatus';
  public static readonly GET_JOIN_SERVER_LOGS = './getJoinServerLogs';
  public static readonly GET_NETWORK_SERVER_STATUS = './getNetworkServerStatus';
  public static readonly GET_NETWORK_SERVERS_OF_NS_GROUP = './getNetworkServersOfNSGroup';
  public static readonly GET_RF_PARAM_SET_ELEMENTS = './getRfParamSetElements';
  public static readonly GET_ALL_ROAMING_COMMUNITIES = './getAllRoamingCommunities';
  public static readonly GET_ALL_NETWORK_SERVERS_WOR = './getAllNetworkServersWoR';
  public static readonly GET_ROAMING_PARTNERS = './getRoamingPartners';
  public static readonly GET_ALL_NETWORK_SERVERS_WOA = './getAllNetworkServersWoA';
  public static readonly GET_SERVED_NETWORK_SERVERS = './getServedNetworkServers';
  public static readonly GET_ALL_JOIN_SERVERS_WOA = './getAllJoinServersWoA';
  public static readonly GET_SERVING_JS_SERVERS = './getServingJsServers';
  public static readonly EXISTS_NSID = './exists/nsId';
  public static readonly EXISTS_NAME = './exists/nnName';
  public static readonly CREATE_NETWORK_SERVER = './createNetworkServer';
  public static readonly EXISTS_SUBNWKID = './exists/subnwkId';
  public static readonly GET_ROAMING_COMMUNITY_MEMBERS = './getRoamingCommunityMembers';
  public static readonly GET_ALL_NETWORK_SERVERS_NO_IRC = './getAllNetworkServersNoiRC';
  public static readonly UPDATE_HTTP_MODE = './update/httpMode';
  public static readonly EXISTS_JOIN_EUI = './exists/joinEUi';
  public static readonly EXISTS_NET_ID = './exists/netId';
  public static readonly UPDATE_NET_IDS = './update/netIds';
  public static readonly UPDATE_JOIN_EUIS = './update/joinEUIs';
  public static readonly UPDATE_NS_GROUP = './update/nsGroup';
  public static readonly CREATE_JOIN_SERVER = './createJoinServer';
  public static readonly CREATE_NETWORK_SERVER_GROUP = './createNetworkServerGroup';
  public static readonly CREATE_ACTIVATION_AGREEMENT = './createActivationAgreement';
  public static readonly CREATE_ROAMING_COMMUNITY_MEMBER = './createRoamingCommunityMember';
  public static readonly CREATE_ROAMING_PARTNER = './createRoamingPartner';
  public static readonly CREATE_ROAMING_AGREEMENT = './createRoamingAgreement';
  public static readonly EXISTS_RF_PARAM_SET_ID = './exists/rfParamSetId';
  public static readonly ADD_RF_PARAM_SET_ELEMENT = './add/RfParamSetElement';
  public static readonly EXISTS_RC_NAME = './exists/rcName';
  public static readonly CREATE_ROAMING_COMMUNITY = './createRoamingCommunity';
  public static readonly DELETE_JOIN_SERVER = './deleteJoinServer';
  public static readonly DELETE_NETWORK_SERVER = './deleteNetworkServer';
  public static readonly DELETE_NETWORK_SERVER_GROUP = './deleteNetworkServerGroup';
  public static readonly DELETE_ROAMING_AGREEMENT = './deleteRoamingAgreement';
  public static readonly DELETE_ACTIVATION_AGREEMENT = './deleteActivationAgreement';
  public static readonly REMOVE_RF_PARAM_SET_ELEMENT = './remove/RfParamSetElement';
  public static readonly DELETE_ROAMING_COMMUNITY = './deleteRoamingCommunity';
  public static readonly DELETE_ROAMING_COMMUNITY_MEMBER = './deleteRoamingCommunityMember';
  public static readonly GET_ACTIVATION_AGREEMENT = './getActivationAgreement';
  public static readonly GET_EDIT_ROAMING_AGREEMENT = './getEditRoamingAgreement';
  public static readonly SET_EDIT_ROAMING_AGREEMENT = './setEditRoamingAgreement';
  public static readonly UPDATE_RC_NAME = '/update/rc/name';
  public static readonly UPDATE_NAME = './update/name';
  public static readonly UPDATE_NS_ID = './update/nsId';
  public static readonly UPDATE_SUBSCRIBER_ID = './update/subscriberId';
  public static readonly UPDATE_URL_FNS = './update/urlFns';
  public static readonly UPDATE_URL_SNS = './update/urlSns';
  public static readonly UPDATE_URL_HNS = './update/urlHns';
  public static readonly UPDATE_URL_JS = './update/urlJS';
  public static readonly UPDATE_URL_CLAIM = './update/urlClaim';
  public static readonly UPDATE_AUTH_USERNAME = './update/authUsername';
  public static readonly UPDATE_AUTH_PASSWORD = './update/authPassword';
  public static readonly UPDATE_OWNER = './update/owner';
  public static readonly UPDATE_PLATFORM = './update/platform';
  public static readonly UPDATE_HELIUM_MEMBER = './update/heliumMember';
  public static readonly GET_ROAMING_AGREEMENT_PEERINGS = './roamingAgreementPeerings';
  public static readonly UPDATE_AUTH = './update/auth';
  public static readonly UPDATE_RC_PROTOCOL_VERSION = '/update/rc/protocolVersion';
  public static readonly UPDATE_PROTOCOL_VERSION = './update/protocolVersion';
  public static readonly UPDATE_SECURITY = './update/security';
  public static readonly GET_NETWORK_SERVER_LOGS = './getNetworkServerLogs';
  public static readonly GET_NETWORK_SERVER_GROUP_LOGS = './getNetworkServerGroupLogs';
}
